import {
	GET_TOTAL_CASE_AMOUNT,
	GET_TOTAL_CASE_AMOUNT_SUCCESS,
	GET_TOTAL_CASE_AMOUNT_FAIL,
	GET_TOTAL_CASE_AMOUNT_RESET,
} from '../actions/getTotalCaseAmountAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getTotalCaseAmountReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_TOTAL_CASE_AMOUNT:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_TOTAL_CASE_AMOUNT_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_TOTAL_CASE_AMOUNT_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_TOTAL_CASE_AMOUNT_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getTotalCaseAmountReducer;
